import React from "react";
import styles from "./DateDivider.module.scss";

interface DateDividerProps {
  date: string;
}

/**
 * Date divider component to separate messages by date
 * Displays a horizontal line with date text in the center
 */
export const DateDivider: React.FC<DateDividerProps> = ({ date }) => {
  return (
    <div className={styles.dateDivider}>
      <div className={styles.line} />
      <span className={styles.dateText}>{date}</span>
      <div className={styles.line} />
    </div>
  );
};
